import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";
import SectionHeading from "@/components/SectionHeading";
import { useSectionContent } from "@/hooks/useContent";

export default function PastRides() {
  const c = useSectionContent("past");
  const { data: past = [] } = useQuery({
    queryKey: ["past-events"],
    queryFn: async () => (await api.get("/past-events")).data,
  });

  if (past.length === 0) return null;

  return (
    <section id="raduni" data-testid="past-rides-section" className="py-24 sm:py-32 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          overline={c.overline}
          title={c.title}
          description={c.description}
          testid="past-rides-heading"
        />

        <div className="mt-14 grid md:grid-cols-2 gap-6" data-testid="past-rides-grid">
          {past.map((ride, i) => (
            <motion.article
              key={ride.id}
              data-testid={`past-ride-${ride.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="leather-card group overflow-hidden"
            >
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={ride.image_url}
                  alt={ride.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B]/90 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 flex items-center gap-2 bg-[#0A0A0B]/85 backdrop-blur px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#C5A059] border border-[#C5A059]/30">
                  <CalendarDays className="w-3 h-3" />
                  {ride.year}
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-semibold text-[#F4EBE1]">{ride.title}</h3>
                {ride.description && (
                  <p className="mt-2 text-sm text-[#C0B9B0] leading-relaxed">{ride.description}</p>
                )}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
